const V3Worker = require('worker-loader!./V3Worker') as any;

export {
    V3Worker
};